import * as Yup from 'yup';
import { CasesGeneralClaims } from '../../../../../../shared/types/modules/cases-general';

export const initialValues: CasesGeneralClaims = {
    dateEvent: '',
    status: '',
    correspondenceFiling: '',
    description: '',
    observation: '',
};

export const validationSchema = Yup.object({
    dateEvent: Yup.string().required('La fecha de reclamo es obligatoria'),
    status: Yup.string().required('El estado es obligatorio'),
    description: Yup.string().required(
        'La descripción de los hechos es obligatoria'
    ),
    correspondenceFiling: Yup.string()
        .max(
            200,
            'El radicado de correspondencia debe tener 200 caracteres alfanuméricos como máximo'
        )
        .matches(
            /^[a-zA-Z0-9\s]*$/,
            'El radicado de correspondencia solo debe contener caracteres alfanuméricos'
        ),
    observation: Yup.string().required('Las observaciones son obligatiorias'),
});
